import { createSlice } from '@reduxjs/toolkit';
import { InvoicesState } from './types';
import { fetchInvoices, downloadInvoiceFile } from './thunk';

const initialState: InvoicesState = {
  data: [],
  count: 0,
  next: null,
  previous: null,
  loading: false,
  error: null,
  downloadLoading: false,
  downloadError: null,
};

const invoicesSlice = createSlice({
  name: 'payments/invoices',
  initialState,
  reducers: {
    resetInvoicesState: () => initialState,
    clearDownloadError: (state) => {
      state.downloadError = null;
    },
    clearInvoicesError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchInvoices.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchInvoices.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.count = payload.count;
        state.next = payload.next;
        state.previous = payload.previous;
        state.data = payload.results;
      })
      .addCase(fetchInvoices.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload ?? 'Failed to load invoices';
      })
      .addCase(downloadInvoiceFile.pending, (state) => {
        state.downloadLoading = true;
        state.downloadError = null;
      })
      .addCase(downloadInvoiceFile.fulfilled, (state) => {
        state.downloadLoading = false;
        state.downloadError = null;
      })
      .addCase(downloadInvoiceFile.rejected, (state, { payload }) => {
        state.downloadLoading = false;
        state.downloadError = payload ?? 'Failed to download invoice';
      });
  },
});

export const { resetInvoicesState, clearDownloadError, clearInvoicesError } =
  invoicesSlice.actions;
export default invoicesSlice.reducer;
